import { api } from '@/shared/services/api';
import { IPlanRepository } from '../../domain/repositories/IOrganizationRepository';
import { Plan } from '../../domain/entities/Plan';

interface PlanApiItem {
  id: string;
  name: string;
  users: number;
  tasks: number;
  connections: number;
  workspaces: number;
}

/**
 * PlanHttpRepository (Adapter)
 *
 * Único endpoint: `GET /v2/organizations/plans`, sin prefijo por rol. El legacy bifurcaba
 * `/admin/plans` (superadmin) vs `/org/plans` (admin) — este segundo path nunca existió
 * realmente (el router legacy montaba en `/organizations/plans`, no en `/org/plans`). Ambos
 * quedan retirados en favor del endpoint v2 (change `h2a-port-auth-me-and-plans-to-v2`, D7).
 *
 * Delta de comportamiento benigno: el catálogo v2 ordena por `order` (comercial); el legacy
 * devolvía el orden arbitrario de Firestore. El conjunto de planes es idéntico.
 */
export class PlanHttpRepository implements IPlanRepository {
  async list(): Promise<Plan[]> {
    const response = await api.get<{ data: PlanApiItem[] }>('/v2/organizations/plans');
    return response.data.data.map((item) =>
      Plan.fromPrimitives({
        id: item.id,
        name: item.name,
        users: item.users,
        tasks: item.tasks,
        connections: item.connections,
        workspaces: item.workspaces,
      })
    );
  }
}
